<script setup lang="ts">
import TCCalendar from "@/components/models/scheduling/TCTeamSchedule.vue";
import { useAbility } from "@casl/vue";
import { definePage } from "unplugin-vue-router/runtime";

definePage({
  meta: {
    title: "generic.entity.scheduling",
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.READ, $permSubjects.SCHEDULING__CALENDAR);
    },
  },
});
</script>

<template>
  <t-c-calendar />
</template>

<style scoped></style>
